// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TCreateDemoUserRequestPayload,
  TCreateDemoUserResponsePayload,
  TGetEmailOidcRequestPayload,
  TGetEmailOidcResponsePayload,
  TLoginAsDemoUserResponsePayload,
  TLoginCallbackRequestPayload,
  TLoginCallbackResponsePayload,
  TLoginRequestPayload,
  TLoginResponsePayload,
  TLoginWithOidcRequestPayload,
  TLoginWithOidcResponsePayload,
  TLogoutResponsePayload,
  TRevokeRefreshTokenRequestPayload,
  TRevokeRefreshTokenResponsePayload,
  TSendSignInLinkToEmailRequestPayload,
  TSendSignInLinkToEmailResponsePayload,
} from './auth.types.ts';

export const createAuthApi = (transport: TApiTransport) => ({
  /** Creates a demo user */
  createDemoUser: (
    payload: TCreateDemoUserRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TCreateDemoUserRequestPayload,
      TCreateDemoUserResponsePayload
    >('/create_demo_user', payload, options),

  /** Returns the OIDC provider for an email */
  getEmailOidc: (
    payload: TGetEmailOidcRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TGetEmailOidcRequestPayload, TGetEmailOidcResponsePayload>(
      '/get_email_oidc',
      payload,
      options,
    ),

  /** Logs the user in */
  login: (payload: TLoginRequestPayload, options?: TApiRequestOptions) =>
    transport.post<TLoginRequestPayload, TLoginResponsePayload>(
      '/login',
      payload,
      options,
    ),

  /** Logs in as a demo user */
  loginAsDemoUser: (options?: TApiRequestOptions) =>
    transport.post<undefined, TLoginAsDemoUserResponsePayload>(
      '/login_as_demo_user',
      undefined,
      options,
    ),

  /** Completes the WorkOS login, returns the signed-in user and sets the sealed wos_session cookie */
  loginCallback: (
    payload: TLoginCallbackRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TLoginCallbackRequestPayload, TLoginCallbackResponsePayload>(
      '/login_callback',
      payload,
      options,
    ),

  /** Logs the user in via OIDC */
  loginWithOidc: (
    payload: TLoginWithOidcRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TLoginWithOidcRequestPayload, TLoginWithOidcResponsePayload>(
      '/login_with_oidc',
      payload,
      options,
    ),

  /** Logs the user out and clears the wos_session cookie */
  logout: (options?: TApiRequestOptions) =>
    transport.post<undefined, TLogoutResponsePayload>(
      '/logout',
      undefined,
      options,
    ),

  /** Revokes the user's refresh token */
  revokeRefreshToken: (
    payload: TRevokeRefreshTokenRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TRevokeRefreshTokenRequestPayload,
      TRevokeRefreshTokenResponsePayload
    >('/revoke_refresh_token', payload, options),

  /** Sends a sign-in link to an email */
  sendSignInLinkToEmail: (
    payload: TSendSignInLinkToEmailRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TSendSignInLinkToEmailRequestPayload,
      TSendSignInLinkToEmailResponsePayload
    >('/send_sign_in_link_to_email', payload, options),
});
